<template>
  <div class="mt-5">
    <section-title
      content="Datos de Servicio"
      icon="fas fa-hand-holding"
      reverse
    />
    <div class="bg-secondary-3 rounded pr-3 pl-3 mt-3 pb-4 pt-4">
      <div class="color-gray-6 font-14">
        Evaluación(es):
      </div>
      <div class="items__container">
        <span
          v-for="item in evaluations"
          :key="item.id"
          class="item__container"
        >
          {{ item.name }}
        </span>
      </div>
    </div>
    <div class="bg-secondary-3 rounded pr-3 pl-3 mt-3 pb-4 pt-4">
      <div class="color-gray-6 font-14">
        Terapia(s):
      </div>
      <div class="items__container">
        <span v-for="item in therapies" :key="item.id" class="item__container">
          {{ item.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';

export default {
  name: 'ProvidedServices',
  components: {
    SectionTitle,
  },
  props: {
    evaluations: {
      type: Array,
      default: () => [],
    },
    therapies: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.items__container {
  display: block;
}

.item__container {
  display: inline-block;
  background-color: white;
  margin: 5px;
  padding: 4px 8px;
  border: 1px solid #d6ddd9;
  border-radius: 20px;
  margin-left: 0;
}

::v-deep i.fa-hand-holding {
  margin-top: 0 !important;
  display: block !important;
}
</style>
